// Per-role theme tokens. Keeps the navy/gold brand cohesive while giving
// each role a unique accent and identity.
import { Home, Briefcase, Building2, Scale, Banknote, Hammer, FileSignature, ShieldCheck } from "lucide-react";

export const ROLE_THEMES = {
  seller: {
    label: "Seller",
    tagline: "Homeowner Portal",
    icon: Home,
    accent: "#10B981",       // emerald
    accentSoft: "#ECFDF5",
    accentText: "#065F46",
    badgeBg: "#ECFDF5",
    badgeText: "#065F46",
    badgeBorder: "#6EE7B7",
  },
  investor: {
    label: "Investor",
    tagline: "Buyer Portal",
    icon: Briefcase,
    accent: "#D4AF37",       // gold (brand)
    accentSoft: "#FEF9E7",
    accentText: "#7A5E0F",
    badgeBg: "#FEF9E7",
    badgeText: "#7A5E0F",
    badgeBorder: "#E6C24F",
  },
  realtor: {
    label: "Realtor",
    tagline: "Agent Portal",
    icon: Building2,
    accent: "#0EA5E9",       // sky
    accentSoft: "#E0F2FE",
    accentText: "#075985",
    badgeBg: "#E0F2FE",
    badgeText: "#075985",
    badgeBorder: "#7DD3FC",
  },
  attorney: {
    label: "Attorney",
    tagline: "Legal Portal",
    icon: Scale,
    accent: "#6366F1",       // indigo
    accentSoft: "#EEF2FF",
    accentText: "#3730A3",
    badgeBg: "#EEF2FF",
    badgeText: "#3730A3",
    badgeBorder: "#A5B4FC",
  },
  lender: {
    label: "Lender",
    tagline: "Funding Portal",
    icon: Banknote,
    accent: "#14B8A6",       // teal
    accentSoft: "#CCFBF1",
    accentText: "#115E59",
    badgeBg: "#CCFBF1",
    badgeText: "#115E59",
    badgeBorder: "#5EEAD4",
  },
  contractor: {
    label: "Contractor",
    tagline: "Repair Portal",
    icon: Hammer,
    accent: "#F59E0B",       // amber
    accentSoft: "#FEF3C7",
    accentText: "#92400E",
    badgeBg: "#FEF3C7",
    badgeText: "#92400E",
    badgeBorder: "#FCD34D",
  },
  title: {
    label: "Title Co.",
    tagline: "Closing Portal",
    icon: FileSignature,
    accent: "#64748B",       // slate
    accentSoft: "#F1F5F9",
    accentText: "#1E293B",
    badgeBg: "#F1F5F9",
    badgeText: "#1E293B",
    badgeBorder: "#CBD5E1",
  },
  admin: {
    label: "Admin",
    tagline: "ADN Operations",
    icon: ShieldCheck,
    accent: "#E11D48",       // rose
    accentSoft: "#FFE4E6",
    accentText: "#9F1239",
    badgeBg: "#FFE4E6",
    badgeText: "#9F1239",
    badgeBorder: "#FDA4AF",
  },
};

export const getRoleTheme = (role) => ROLE_THEMES[role] || ROLE_THEMES.seller;
